<ss-popup *ngIf="cookieConsentIsNeeded"
  (onClose)="onPopupClose($event)">

  <div class="max-width-500">
    <h3 class="popup-title padding-0">
      <span class="popup-title-icon">
        <i class="fas fa-cookie-bite"></i>
      </span>
      This site uses cookies
    </h3>

    <p class="txt-sans-serif margin-top-10 txt-size-base">
      We use cookies to personalize content, provide social media features, improve site performance, and determine which features to improve upon or develop next. To prohibit certain cookies and thereby restrict or remove some features, edit your preferences below. Otherwise, permit all cookies by continuing to use this site.
    </p>


    <div class="clearfix">
      <div class="float-left">
        <a (click)="navigateToCookieConsentPage()"
          class="txt-size-small link-tertiary display-inline-block margin-top-10">
            Edit Preferences
        </a>
      </div>

      <div class="float-right">
        <button type="submit"
          class="btn-primary"
          [class.is-loading]="isSubmitting"
          [disabled]="isSubmitting"
          (click)="acceptAllCookies()">
          Accept
          <lcp-loading *ngIf="isSubmitting" iconColor="white"></lcp-loading>
        </button>
      </div>
    </div>
  </div>

</ss-popup>
